module.exports = __webpack_public_path__ + "static/img/banner@2x.fc2cf823.png";